class MegaMenuButton extends HTMLElement {
  connectedCallback() {
    this.timeout = null;
    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.handleMouseEnter.bind(this));
    if (this.timeout) clearTimeout(this.timeout);
  }

  handleMouseEnter(event) {
    // Be sure to always start with a new timeout
    if (this.timeout) clearTimeout(this.timeout);

    const hoveredElement = event.target;
    // If the user leaves the button, we want to 'reset' the timer
    event.target.addEventListener('mouseleave', this.handleMouseLeave.bind(this), { once: true });
    this.timeout = setTimeout(() => {
      if (hoveredElement.matches(':hover')) {
        publish('mega-menu-button:hover');
      }
    }, 100);
  }

  handleMouseLeave() {
    clearTimeout(this.timeout);
  }
}

customElements.define('mega-menu-button', MegaMenuButton);
